import { styled } from '@linaria/react';

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
`;

export const ContentContainer = styled.div`
    max-height: calc(100vh - 150px);
    overflow-y: auto;
`;

export const HeaderSection = styled.div`
    display: flex;
    gap: 2rem;
    margin-bottom: 1rem;
    padding: 1rem;
    background: #f5f5f5;
`;

export const Column = styled.div`
    flex: 1;
`;

export const FieldRow = styled.div`
    margin-bottom: 0.5rem;
`;

export const FieldLabel = styled.label`
    display: inline-block;
    width: 150px;
    font-weight: bold;
`;

export const ChangesSection = styled.div`
    margin-top: 1rem;
`;

export const SectionHeader = styled.h3<{ color?: string; marginLeft?: string }>`
    color: ${(props) => props.color || '#333'};
    margin: 1rem;
    font-size: 1.2rem;
    ${(props) => props.marginLeft && `margin-left: ${props.marginLeft};`}
`;

export const SectionContainer = styled.div<{ withPadding?: boolean }>`
    margin-bottom: 1.5rem;
    ${(props) => props.withPadding && 'padding: 0 1rem;'}
`;

export const ChangeItem = styled.div`
    margin-bottom: 0.25rem;
`;

export const ChangeBox = styled.div<{ variant: 'removed' | 'added' }>`
    background-color: ${(props) => (props.variant === 'removed' ? '#f2dede' : '#dff0d8')};
    padding: 0.5rem 1rem;
    border-left: 3px solid ${(props) => (props.variant === 'removed' ? '#d9534f' : '#5cb85c')};
`;

export const ChangeBoxContent = styled.div`
    color: #333;
`;

export const BoldText = styled.span`
    font-weight: bold;
`;

export const ColoredLabel = styled.span<{ color: string }>`
    color: ${(props) => props.color};
    font-weight: bold;
`;

export const ChangedFieldContainer = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const ChangedFieldBox = styled.div<{ variant: 'removed' | 'added' }>`
    flex: 1;
    background-color: ${(props) => (props.variant === 'removed' ? '#f2dede' : '#dff0d8')};
    padding: 0.5rem 1rem;
    border-left: 3px solid ${(props) => (props.variant === 'removed' ? '#d9534f' : '#5cb85c')};
`;

export const ValueList = styled.ul`
    margin: 0.5rem 0;
    padding-left: 1.5rem;
`;

export const SuccessMessage = styled.div`
    padding: 1rem;
    background-color: #dff0d8;
    color: #3c763d;
    margin-top: 1rem;
`;

export const ErrorMessage = styled.div`
    padding: 1rem;
    background-color: #f2dede;
    color: #a94442;
    margin-top: 1rem;
`;
